module.exports = __webpack_public_path__ + "static/media/education-object-3-1-0.22b8bdc7.png";